export default __webpack_public_path__ + "static/media/icn-search-active.4e5054a8.svg";